import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useAuth, useLinks, useProfile } from "hooks";
import PageTitle from "components/PageTitle";
import { NavList } from "components/Nav";
import { PrimaryLink } from "components/Links";
import { getFullName } from "utils";

/**
 * ProfileNav
 *
 * @param {String}   id
 */
const ProfileNav = ({ id }) => {
  const { data, loading } = useProfile({ profileId: id });
  const { isAdmin, isPartner, isRecruiter } = useAuth();
  const links = useLinks();

  if (!isAdmin && !isRecruiter && !isPartner) return null;

  const adminNavItems = [
    {
      label: "Profile",
      to: links.private_profile(id),
      isActive: true,
    },
    {
      label: "Interviews",
      to: links.profile_video_interviews(id),
      isActive: true,
    },
    {
      label: "Job Preferences",
      to: links.rate(id),
      isActive: true,
    },
    {
      label: "Code Challenges",
      to: links.profile_code_challenges(id),
      isActive: true,
      isAdmin,
    },
    {
      label: "Applications",
      to: links.profile_applications(id),
      isActive: true,
      isAdmin,
    },
    {
      label: "Assignments",
      to: links.profile_assignments(id),
      isActive: true,
      isAdmin,
    },
    {
      label: "Notes",
      to: links.notes(id),
      isActive: true,
      isAdmin,
    },
    {
      label: "Timeline",
      to: links.timeline(id),
      isActive: true,
      isAdmin,
    },
    {
      label: "Settings",
      to: links.settings(id),
      isActive: true,
    },
  ];

  const partnerNavItems = [
    {
      label: "Profile",
      to: links.private_profile(id),
      isActive: true,
    },
    {
      label: "Interviews",
      to: links.profile_video_interviews(id),
      isActive: true,
    },
    {
      label: "Job Preferences",
      to: links.rate(id),
      isActive: true,
    },
  ];

  return (
    <PageTitle
      title={getFullName(data?.profile, true)}
      backLink={
        <PrimaryLink to={links.network} routerEnabled>
          <FormattedMessage id="Nav.SideNav.LabelNetwork" />
        </PrimaryLink>
      }
      actionBar={<NavList pages={isAdmin || isRecruiter ? adminNavItems : partnerNavItems} routerEnabled end />}
      loading={loading}
      asHeader
    />
  );
};

ProfileNav.propTypes = {
  id: PropTypes.string.isRequired,
};

export default ProfileNav;
